<script setup lang="ts">
import { MarkTypes } from '@storyblok/richtext';
import { type StoryblokRichTextProps } from '@storyblok/vue';
import { Mark } from '@tiptap/core';

// eslint-disable-next-line regex/invalid
import { NuxtLink } from '#components';

// PROPS
type Props = Pick<StoryblokRichTextProps, 'doc'>;
defineProps<Props>();

// METHODS
const convertNodeAttrsToStoryblokMultilink = (attrs: any): StoryblokMultilink => ({
    fieldtype: 'multilink',
    id: attrs?.uuid,
    url: (attrs?.linktype === 'url' || attrs?.linktype === 'asset') && attrs?.href,
    cached_url: attrs?.href,
    target: attrs?.target,
    anchor: attrs?.anchor,
    linktype: attrs?.linktype,
    story: attrs?.story,
    email: attrs?.linktype === 'email' && attrs?.href,
});

// DATA
const CustomLink = Mark.create({
    name: MarkTypes.LINK,
    renderHTML({ HTMLAttributes }) {
        return [
            asTag(NuxtLink),
            { href: storyblokResolveLink(convertNodeAttrsToStoryblokMultilink(HTMLAttributes)), target: HTMLAttributes.target },
            0,
        ];
    },
});
const tiptapExtensions = {
    [MarkTypes.LINK]: CustomLink,
};
</script>

<template>
    <div
        class="prose prose-slate prose-img:rounded-xl w-full [&_[data-type=emoji]>img]:my-0 [&_[data-type=emoji]>img]:inline [&_[id]]:scroll-mt-[var(--ui-header-height)]"
    >
        <StoryblokRichText :doc="doc" :tiptap-extensions="tiptapExtensions" />
    </div>
</template>
